import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link, useNavigate } from "react-router-dom"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"

import { Container, Row, Col, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

import { EnumObjectTypes } from "helpers/enum_helper"
import Document from "../../components/Common/Document"
import { useUserDetail } from "hooks"

function DocumentPage() {
  const { userprofile } = useUserDetail()

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="" breadcrumbItem="Documents" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Document
                    objectID={userprofile?.UserID}
                    objectTypeID={EnumObjectTypes.User}
                    hidePrivacy={false}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default DocumentPage
